/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import CurrencyHelper, { CURRENCY_RATIO, currencyIsoCodes } from '../../../general/js/basket/currency-helper';
import gtm, { ecommerceEventTypes } from '../../../general/js/gtm';
import {
    PRODUCT_TAG_JUNIOR,
    PRODUCT_TAG_YOUTH,
    PRODUCT_TAG_SCORERS_PREMIUM,
    PRODUCT_TAG_ENGRAVERS,
    PRODUCT_TYPE_HOSPITALITY,
    MAX_SCORERS_PREMIUM_TICKETS_AVAILABLE,
    PRODUCT_TAG_SWING_BADGE_GUEST,
    PRODUCT_TAG_SWING_BADGE_ADDITIONAL_GUEST,
    PRODUCT_TAG_SWING_BADGE
} from '../../../general/js/basket/constants';
import PopupLink from './popup-link';

import {
    ROUTE_PARKING_STANDALONE
} from './constants';
import { hasValue } from '../../../general/js/general-helpers';

export default class SelectPanel extends React.Component {
    constructor(props) {
        super(props);

        this.isDecreaseButtonDisabled = true;
        this.isIncreaseButtonDisabled = false;
        this.quantityDelta = 1;
    }

    onSelectBtnClick(quantity, currentQuantity, maxQuantity, startQuantity) {
        let newQuantity = 0;
        const quantityModifierProp = get(this.props, 'quantityModifier', undefined);

        if (quantity === '') { quantity = 0; }

        if (this.props.product.type === PRODUCT_TYPE_HOSPITALITY) {
            const quantityModifier = hasValue(quantityModifierProp) && quantityModifierProp !== 0 ? quantityModifierProp : this.quantityDelta;
            const maxQuantityOnHospitality = Math.floor(maxQuantity / quantityModifier) * quantityModifier;

            if (quantity % quantityModifier > 0) {
                const roundedQuantity = Math.round(quantity / quantityModifier) * quantityModifier;
                newQuantity = roundedQuantity > maxQuantityOnHospitality ? maxQuantityOnHospitality : roundedQuantity;
            } else {
                newQuantity = quantity === currentQuantity ? 0 : (quantity < maxQuantity ? (quantity < startQuantity ? (quantity < currentQuantity ? 0 : startQuantity) : quantity) : maxQuantityOnHospitality);
            }
        } else {
            newQuantity = quantity === currentQuantity ? 0 : (quantity <= maxQuantity ? (quantity < startQuantity ? (quantity < currentQuantity ? 0 : startQuantity) : quantity) : maxQuantity);
        }

        const ecommerceEventState = {
            eventType: '',
            quantityDelta: 0,
            isValid: false,
            newQuantity,
            currentQuantity
        };

        this.handleEcommerceEvent(ecommerceEventState);

        if (window.location.href.includes(ROUTE_PARKING_STANDALONE)) {
            this.props.onApplyProductsQuantity(
                {
                    id: this.props.product.id,
                    type: this.props.product.type,
                    tag: this.props.product.tag
                },
                newQuantity
            );
        } else {
            this.props.onApplyProductsQuantity(
                {
                    type: this.props.product.type,
                    tag: this.props.product.tag
                },
                newQuantity
            );
        }
    }

    handleEcommerceEvent(eventState) {
        if (!this.isIncreaseButtonDisabled && eventState.newQuantity > eventState.currentQuantity) {
            eventState.eventType = ecommerceEventTypes.ADD_TO_CART;
            eventState.quantityDelta = eventState.newQuantity - eventState.currentQuantity;
            eventState.isValid = true;
        } else if (!this.isDecreaseButtonDisabled && eventState.newQuantity < eventState.currentQuantity) {
            eventState.eventType = ecommerceEventTypes.REMOVE_FROM_CART;
            eventState.quantityDelta = eventState.currentQuantity - eventState.newQuantity;
            eventState.isValid = true;
        }

        if (eventState.isValid) {
            const productGroups = this.props.productGroupsList;

            if (productGroups.length && productGroups[0].products.length) {
                const productGroup = productGroups[0];
                const product = productGroup.products[0];
                const productPrice = product.price / CURRENCY_RATIO;

                gtm.pushEcommerceEvent(eventState.eventType, {
                    currency: currencyIsoCodes.GBP,
                    value: productPrice * eventState.quantityDelta,
                    items: [
                        {
                            item_id: product.productId,
                            item_name: `${product.tag} - ${productGroup.title}`,
                            price: productPrice,
                            quantity: eventState.quantityDelta,
                        }
                    ]
                });
            }
        }
    }

    handleChange = (e, startQuantity) => {
        this.onSelectBtnClick(+e.target.value, this.props.product.quantity, this.props.product.maxQuantity, startQuantity);
    }

    generateSummaryText() {
        const product = this.props.product;
        return `${CurrencyHelper.convertToPounds(product.price)}${product.priceLabel ? ` ${product.priceLabel}` : ''}`;
    }

    renderSummary() {
        if (this.props.product.price > 0) {
            return (
                <div className="select-panel__summary">{this.generateSummaryText()}</div>);
        }

        return (<div className="select-panel__summary select-panel__summary--italic">FREE</div>);
    }

    renderCopy() {
        if (this.props.product.tag === PRODUCT_TAG_JUNIOR) {
            return (
                <div className="select-panel__note copy">
                    {this.props.dictionary.juniorTicketsText}&nbsp;<PopupLink
                        className="tb-form__footer-link link"
                        href={this.props.dictionary.juniorTicketsLinkUrl}
                        aria-label="Get more info or order extra products">{this.props.dictionary.juniorTicketsLinkText}</PopupLink>
                </div>);
        }
        if (this.props.product.tag === PRODUCT_TAG_SWING_BADGE) {
            return (
                <div className="select-panel__note copy">
                    {this.props.dictionary.swingBadgeTicketsText}&nbsp;
                </div>);
        }
        if (this.props.product.tag === PRODUCT_TAG_SWING_BADGE_GUEST) {
            return (
                <div className="select-panel__note copy">
                    {this.props.dictionary.swingBadgeGuestTicketsText}&nbsp;
                </div>);
        }
        if (this.props.product.tag === PRODUCT_TAG_SWING_BADGE_ADDITIONAL_GUEST) {
            return (
                <div className="select-panel__note copy">
                    {this.props.dictionary.swingBadgeAdditionalGuestTicketsText}&nbsp;
                </div>);
        }
        return null;
    }

    renderSelectButton(startQuantity) {
        let stateCCDecrease = '';
        let stateCC = '';
        const { quantityModifier } = this.props;

        if (this.props.product.type === PRODUCT_TYPE_HOSPITALITY) {
            this.quantityDelta = hasValue(quantityModifier) && quantityModifier !== 0 ? quantityModifier : this.quantityDelta;
        }

        if (this.props.product.quantity === 0) {
            stateCCDecrease += ' is-disabled';
            this.isDecreaseButtonDisabled = true;
        } else {
            this.isDecreaseButtonDisabled = false;
        }

        if (this.props.product.quantity >= this.props.product.maxQuantity || (this.props.product.quantity + this.quantityDelta) > this.props.product.maxQuantity) {
            stateCC += ' is-disabled';
            this.isIncreaseButtonDisabled = true;
        } else {
            this.isIncreaseButtonDisabled = false;
        }

        return (
            <React.Fragment>
                <button
                    type="button"
                    className={`select-panel__button ${stateCCDecrease}`}
                    id={`decreaseQuantity-${this.props.product.tag}`}
                    key={`decreaseQuantity-${this.props.product.audienceSubcategoryId}`}
                    onClick={() => this.onSelectBtnClick(this.props.product.quantity - this.quantityDelta, this.props.product.quantity, this.props.product.maxQuantity, startQuantity)}
                    disabled={this.props.product.isDisabled}
                    aria-label={`${this.props.product.title} ticket, decrease quantity`}>
                    <span className="button-content">
                        <svg className="icon" width="13" height="11" focusable="false">
                            <use xlinkHref="#icon-minus"></use>
                        </svg>
                    </span>
                </button>
                <input className="select-panel__input" value={this.props.product.quantity} min="0" max={`${this.props.product.maxQuantity}`}
                    onChange={(e) => this.handleChange(e, startQuantity)}>
                </input>
                <button
                    type="button"
                    className={`select-panel__button ${stateCC}`}
                    id={`increaseQuantity-${this.props.product.tag}`}
                    key={`increaseQuantity-${this.props.product.audienceSubcategoryId}`}
                    onClick={() => this.onSelectBtnClick(this.props.product.quantity + this.quantityDelta, this.props.product.quantity, this.props.product.maxQuantity, startQuantity)}
                    disabled={this.props.product.isDisabled}
                    aria-label={`${this.props.product.title} ticket, increase quantity`}>
                    <span className="button-content">
                        <svg className="icon" width="13" height="11" focusable="false">
                            <use xlinkHref="#icon-plus"></use>
                        </svg>
                    </span>
                </button>
            </React.Fragment>
        );
    }

    renderSelectButtons() {
        const buttonsNodes = [];
        let startQuantity = 1;
        //if there are less available tickets than the maximum tickets allow to buy once
        if (this.props.product.maxQuantity > this.props.product.maxAvailable) {
            this.props.product.maxQuantity = this.props.product.maxAvailable;
        }

        if (this.props.product.tag === PRODUCT_TAG_SWING_BADGE || this.props.product.tag === PRODUCT_TAG_SWING_BADGE_GUEST || this.props.product.tag === PRODUCT_TAG_SWING_BADGE_ADDITIONAL_GUEST) {
            buttonsNodes.push(this.renderSelectButton(startQuantity));
            return buttonsNodes;
        }

        if (this.props.product.tag === PRODUCT_TAG_SCORERS_PREMIUM) {
            startQuantity = MAX_SCORERS_PREMIUM_TICKETS_AVAILABLE;
            buttonsNodes.push(this.renderSelectButton(startQuantity));
        } else if (this.props.product.tag === PRODUCT_TAG_ENGRAVERS) {
            startQuantity = 2;

            buttonsNodes.push(this.renderSelectButton(startQuantity));
        } else {
            buttonsNodes.push(this.renderSelectButton(startQuantity));
        }

        return buttonsNodes;
    }

    render() {
        const product = this.props.product;
        const rootCssClass = this.props.rootCssClass || '';
        const rootCssModificator = this.props.product.tag === PRODUCT_TAG_YOUTH || this.props.product.tag === PRODUCT_TAG_SWING_BADGE_GUEST || this.props.product.tag === PRODUCT_TAG_SWING_BADGE_ADDITIONAL_GUEST ?
            'select-panel--grey' : '';

        const isSelected = product.quantity && product.quantity > 0;
        const isSoldOut = !isSelected && product.isSoldOut;

        return (
            <div
                className={`${rootCssClass} select-panel ${rootCssModificator} ${isSoldOut ? 'is-sold-out' : ''} ${this.props.product.maxQuantity <= 4 ? 'select-panel--stretch' : ''}`}>
                <div className="select-panel__main">
                    <div className="select-panel__info">
                        <h4 className="select-panel__heading">
                            <span>{product.title}</span>
                            {
                                product.bracketsText ?
                                    <span className="select-panel__more">{product.bracketsText}</span> : ''
                            }
                        </h4>
                        {this.renderSummary()}
                    </div>
                    {
                        !isSoldOut ? <div
                            className="select-panel__controls">
                            {this.renderSelectButtons()}
                        </div> : null
                    }
                </div>
                {this.renderCopy()}
            </div>
        );
    }
}

SelectPanel.propTypes = {
    dictionary: PropTypes.object.isRequired,
    product: PropTypes.object,
    productGroupsList: PropTypes.array,
    onApplyProductsQuantity: PropTypes.func,
    rootCssClass: PropTypes.string,
    currentScenario: PropTypes.string
};
